module.exports = __webpack_public_path__ + "static/img/SearchDetailBorn1.221cd49.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailBorn1.png
// module id = 709
// module chunks = 0